/**
 * Cloud VMs on the Machines page (ADR 0106): the cards of VMs Orgus created whose machine has
 * not joined yet, and the VM section of a machine's drawer. Each reads state.ext.cloud itself,
 * so the page only places them.
 */
import { useOrgus } from '../../lib/store.ts';
import { CARD_SURFACE } from '../machines/MachineCard.tsx';
import { useCloud } from './data.ts';
import { vmOfMachine, vmsWithoutMachine } from './model.ts';
import { VmCard, VmDetails } from './VmControls.tsx';
import type { VmFailure } from './VmControls.tsx';

/** VMs still starting (or stopped before they joined), as cards above the machines. */
export function PendingVms({ now, onFail }: { now: number; onFail: (f: VmFailure) => void }) {
  const { state } = useCloud();
  const machines = useOrgus((s) => s.machines);
  const vms = vmsWithoutMachine(state, machines);
  if (!vms.length) return null;
  return (
    <section aria-label="Cloud VMs joining" className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3 3xl:grid-cols-4" data-testid="pending-vms">
      {vms.map((vm) => (
        <VmCard key={vm.id} vm={vm} now={now} onFail={onFail} className={CARD_SURFACE} />
      ))}
    </section>
  );
}

/** The drawer's Cloud VM section, for a machine Orgus created. */
export function MachineVm({ machineId, now }: { machineId: string; now: number }) {
  const { state } = useCloud();
  const vm = vmOfMachine(state, machineId);
  return vm ? <VmDetails vm={vm} now={now} /> : null;
}
